<div class="connect-tag">
	<img src="/assets/images/kwo-connect.png" alt="KWO" width="64" height="64">
</div>